import React, { useState } from 'react';
import { Laptop, Smartphone, Tablet, Plus, Trash2, Pencil, AlertTriangle, CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';
import { api, errMsg } from '../api';
import { Card, SectionTitle, goldBtn } from '../ui';
import DeviceForm, { EMPTY } from './DeviceForm';

const ICON = { computer: Laptop, smartphone: Smartphone, tablet: Tablet };

function DeviceRow({ d, onEdit, onDelete }) {
  const Icon = ICON[d.kind];
  return (
    <div className="px-6 py-3 border-t border-[#1F242C] flex flex-wrap items-center gap-x-4 gap-y-2 text-sm" data-testid={`device-row-${d.id}`}>
      <Icon size={18} className="text-[#D4AF37] shrink-0" />
      <span className="min-w-[160px] flex-1"><b>{d.name}</b><span className="text-[#7A7F87]"> · {d.assignee || 'non assegnato'} · {d.os || 'SO n.d.'} · {d.ownership}</span></span>
      {d.issues.length ? <span className="flex flex-wrap gap-1.5">{d.issues.map((x) => <span key={x} className="text-xs px-2 py-0.5 rounded-full bg-[#C0392B]/15 text-[#E57368]">{x}</span>)}</span>
        : <span className="text-xs text-[#2E9E6A] inline-flex items-center gap-1"><CheckCircle2 size={13} />Nessun punto debole</span>}
      <button onClick={() => onEdit(d)} className="text-[#A3A3A3] hover:text-[#D4AF37]" data-testid={`device-edit-${d.id}`}><Pencil size={15} /></button>
      <button onClick={() => onDelete(d)} className="text-[#A3A3A3] hover:text-[#C0392B]" data-testid={`device-delete-${d.id}`}><Trash2 size={15} /></button>
    </div>
  );
}

export default function DevicesConsole({ rows, reload }) {
  const [edit, setEdit] = useState(null);
  const save = async (f) => {
    try { await (f.id ? api.put(`/nis2/devices/${f.id}`, f) : api.post('/nis2/devices', f)); setEdit(null); reload(); toast.success('Dispositivo salvato'); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const del = async (d) => { if (!window.confirm(`Eliminare ${d.name}?`)) return; await api.delete(`/nis2/devices/${d.id}`).catch((e) => toast.error(errMsg(e))); reload(); };
  const weak = rows.filter((d) => d.issues.length).length;
  const count = (k) => rows.filter((d) => d.kind === k).length;
  return (
    <Card className="mt-4" data-testid="devices-registry">
      <div className="px-6 pt-6"><SectionTitle right={<button onClick={() => setEdit(EMPTY)} className={`h-9 px-4 text-sm whitespace-nowrap inline-flex items-center gap-2 ${goldBtn}`} data-testid="device-add-btn"><Plus size={14} />Aggiungi</button>}>Registro device aziendali</SectionTitle></div>
      <div className="px-6 pb-4 flex flex-wrap gap-6 text-sm" data-testid="devices-summary">
        <span><b className="text-lg">{count('computer')}</b> computer</span><span><b className="text-lg">{count('smartphone')}</b> smartphone</span><span><b className="text-lg">{count('tablet')}</b> tablet</span>
        <span className={weak ? 'text-[#E57368] inline-flex items-center gap-1' : 'text-[#2E9E6A]'}>{weak ? <AlertTriangle size={14} /> : null}{weak} con punti deboli</span>
      </div>
      {edit && <DeviceForm initial={edit} onSave={save} onCancel={() => setEdit(null)} />}
      {rows.length === 0 && !edit ? <p className="px-6 py-5 border-t border-[#1F242C] text-sm text-[#7A7F87]">Nessun dispositivo inserito: aggiungi computer e smartphone aziendali per vedere i punti deboli.</p>
        : rows.map((d) => <DeviceRow key={d.id} d={d} onEdit={setEdit} onDelete={del} />)}
      {weak > 0 && <p className="px-6 py-4 border-t border-[#1F242C] text-sm text-[#A3A3A3]">Per mettere in sicurezza i dispositivi da un'unica console vedi <a href="/portal/richieste/mdm" className="text-[#D4AF37] underline" data-testid="devices-mdm-link">Device Management</a>.</p>}
    </Card>
  );
}
